// extracted by mini-css-extract-plugin
module.exports = {"secondaryButton":"secondaryButton_secondaryButton__Vi5rO"};